import { UpdateSubscriptionRequest } from '../../types/requests/subscriptions'
import { SubscriptionCollection } from '../../types/responses/subscriptions'
import apiService from './apiService'

export default new (class SubscriptionService {
  private endpoint = '/v1/subscriptions'

  async getCompanySubscriptions(
    companyId: number,
  ): Promise<SubscriptionCollection> {
    const response = await apiService.get(
      `/v1/companies/${companyId}/subscriptions`,
    )

    return response.data
  }

  async getCompanyUserSubscriptions(
    companyUserId: number,
  ): Promise<SubscriptionCollection> {
    const response = await apiService.get(
      `/v1/company-users/${companyUserId}/subscriptions`,
    )

    return response.data
  }

  async dismissExpiringSoonBanner(subscriptionId: number) {
    return this.patch(subscriptionId, {
      expiringSoonBannerDismissed: true,
    })
  }

  async dismissExpiringUrgentlyBanner(subscriptionId: number) {
    return this.patch(subscriptionId, {
      expiringUrgentlyBannerDismissed: true,
      // We mark this as dismissed too, so we don't show the expiring
      // soon banner after dismissing the expiring urgently banner.
      expiringSoonBannerDismissed: true,
    })
  }

  private async patch(
    subscriptionId: number,
    payload: UpdateSubscriptionRequest,
  ) {
    const response = await apiService.patch(
      `${this.endpoint}/${subscriptionId}`,
      payload,
    )

    return response.data
  }
})()
